/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTExLjUsNS4ybC43LS43aDMuM1YuNWgtNFYzLjhsLS43LjdINS4ybC0uNy0uN1YuNUguNXY0SDMuOGwuNy43djUuNmwtLjcuN0guNXY0aDRWMTIuMmwuNy0uN2g1LjZsLjcuN3YzLjNoNHYtNEgxMi4ybC0uNy0uN1ptMS0zLjdoMnYyaC0yWm0tOSwyaC0ydi0yaDJabTAsMTFoLTJ2LTJoMlptNy00aC01di01aDVabTIsMmgydjJoLTJaIi8+PC9zdmc+";